export const POSITION_ACTIONS = {
  buy: 'buy',
  sell: 'sell',
  move: 'move',
  delete: 'delete',
  addNewHolding: 'addNewHolding',
}